import { useMutation, useQuery } from "@tanstack/react-query";
import { getPagesSettings, updatePagesSettings } from "api/siteSettings/pages";
import { queryClient } from "client";
import { printError, useSearch, useUtilities } from "helpers";
import { t } from "i18next";

export const usePages = () => {
  const { web = null } = useSearch();
  return useQuery(["getPagesSettings", web], () => getPagesSettings(web), {
    select: (data) => {
      if (Array.isArray(data?.data)) {
        return data.data.find((ele) => ele.website_id === web);
      }
      return {};
    },
  });
};

export const useUpdatePagesSettings = () => {
  const { web = null } = useSearch();
  const { notification } = useUtilities();
  return useMutation((params) => updatePagesSettings(web, params), {
    onSuccess: (data) => {
      if (data.status_code === 200) {
        notification({
          type: "success",
          message: t("siteSetting.pages.api.response.update"),
        });
        queryClient.invalidateQueries(["getPagesSettings"]);
      } else {
        notification({
          type: "error",
          message: t("siteSetting.pages.api.response.failed"),
        });
      }
    },
    onError: (error) => {
      notification({
        type: "error",
        message: printError(error.response?.data?.message),
      });
    },
  });
};
